import React from "react";
import Alert from 'react-bootstrap/Alert';
import { Carousel } from "react-bootstrap";

function Home({ homeContent }) {
  if (!homeContent) return null;

  return (
    <>
      <div className="homepage-container">
        <Carousel fade interval={2500} pause={false}>
          {homeContent.sliders.map((slide) => (
            <Carousel.Item key={slide.id}>
              <img
                className="d-block w-100"
                src={`https://admin.victoryvalleyrwa.com/uploads/sliders/${slide.image}`}
                alt={slide.title || "Slide image"}
              />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <section className="section p-md-5" id="achievements">
        <div className="container">
          <div className="row align-items-center">
            <h2 className="blue text-center mb-4">Achievements</h2>
            {[
              { backcolor: 'primary', key: 'achievement_1' },
              { backcolor: 'success', key: 'achievement_2' },
              { backcolor: 'primary', key: 'achievement_3' },
            ].map((variant, index) => (
              <div
                className="col-md-4 text-center col-12 mb-4 mb-md-0"
                key={index}
              >
                <Alert
                  variant={variant.backcolor}
                  className="shadow p-4 h-100"
                  style={{ borderRadius: "1.5rem" }}
                >
                  <p
                    dangerouslySetInnerHTML={{
                      __html: homeContent.content[variant.key],
                    }}
                  />
                </Alert>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section
        id="home"
        style={{
          height: '550px',
          padding: '50px',
          backgroundImage: `url(https://admin.victoryvalleyrwa.com/uploads/home/${homeContent?.content?.about_company_image})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: '55%',
          backgroundPosition: 'right top',
          backgroundColor: '#5083d5',
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-6 welcomebox">
              <h2 className="headingdotstyl green mt-4">{homeContent.content.welcome_heading}</h2>
              <div
                dangerouslySetInnerHTML={{ __html: homeContent.content.about_company }}
              />
            </div>
          </div>
        </div>
      </section>

      <section
        id="rwafocuspoint"
        style={{ height: 'auto', padding: '50px', backgroundColor: '#f8f9fa' }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h2 className="headingdotstyl blue">{homeContent.content.key_focus_heading}</h2>
            </div>
            <div className="col-md-12">
              <div dangerouslySetInnerHTML={{ __html: homeContent.content.key_focus_contents }} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Home;
